<template>
    <div class="sb-simple-airport-product-card" data-test="sb-simple-airport-product-card">
        <UiProductsCardsSimpleAirportProduct v-editable="blok" :blok="blok" />
    </div>
</template>

<script lang="ts" setup>
import type { ISimpleAirportProduct } from '@nuxt-monorepo/ui/types/components/ProductsCards/SimpleAirportProduct';

defineProps<{
    blok: ISimpleAirportProduct;
}>();
</script>

<style lang="postcss" scoped></style>
